import styled from 'styled-components';

export const ConfirmMethodTitle = styled.h2`
  ${(props) => props.theme.typography.label};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 8px;
`;

// Miscellaneous Card styles

export const CardTitle = styled.h2`
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const CardWrapper = styled.div`
  margin-bottom: 32px;
`;

export const CardSubtitle = styled.p`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 24px;
`;

// Ask Order styles

export const OrderHeader = styled.h3`
  ${(props) => props.theme.typography.subHeader2};
  margin-bottom: 8px;
`;

export const OrderDescription = styled.p`
  ${(props) => props.theme.typography.subHeader2};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 8px;
`;

export const OrderNotification = styled.div`
  margin-bottom: 24px;
`;
